export enum TooltipPlacement {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Auto = 'auto',
  AutoEnd = 'auto-end',
  AutoStart = 'auto-start',
  BottomEnd = 'bottom-end',
  BottomStart = 'bottom-start',
  LeftEnd = 'left-end',
  LeftStart = 'left-start',
  RightEnd = 'right-end',
  RightStart = 'right-start',
  TopEnd = 'top-end',
  TopStart = 'top-start',
}
